import { ChakraProvider, createSystem, defaultConfig } from "@chakra-ui/react"
import { AuthProvider } from "@/contexts"
import { ViewerProvider } from "@/contexts/ViewerContext"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "./App.css"

import { Router } from "./routes/Router"

const theme = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        brand: {
          25: { value: "#3F5EA1" },
          50: { value: "#324C82" },
          100: { value: "#324C82" },
          200: { value: "#3A5691" },
          300: { value: "#3F5EA1" },
          400: { value: "#798EBE" },
          500: { value: "#9FAFD0" },
          600: { value: "#B3C0D9" },
          700: { value: "#C6D0E3" },
          800: { value: "#D9DFED" },
          900: { value: "#ECEFF6" },
        },
        darkBlue: {
          100: { value: "#0D1C46" },
          200: { value: "#253359" },
          300: { value: "#3D496B" },
          400: { value: "#56607E" },
          500: { value: "#6E7790" },
          600: { value: "#868EA3" },
          700: { value: "#B6BBC8" },
          800: { value: "#B6BBC8" },
          900: { value: "#FBFBFC" },
        },
        orange: {
          100: { value: "#FF6937" },
          200: { value: "#FF784B" },
          300: { value: "#FF875F" },
          400: { value: "#FF9673" },
          500: { value: "#FFA587" },
          600: { value: "#FFB49B" },
          700: { value: "#FFC3AF" },
          800: { value: "#FFD2C3" },
          900: { value: "#FFF0EB" },
        },
        yellow: {
          100: { value: "#FFC043" },
          200: { value: "#FFCD69" },
          300: { value: "#FFD37B" },
          400: { value: "#FFD98E" },
          500: { value: "#FFE0A1" },
          600: { value: "#FFE6B4" },
          700: { value: "#FFECC7" },
          800: { value: "#FFF2D9" },
          900: { value: "#FFF9EC" },
        },
        green: {
          100: { value: "#3CC68A" },
          200: { value: "#50CC96" },
          300: { value: "#63D1A1" },
          400: { value: "#77D7AD" },
          500: { value: "#8ADDB9" },
          600: { value: "#9EE3C5" },
          700: { value: "#B1E8D0" },
          800: { value: "#D8F4E8" },
          900: { value: "#ECF9F3" },
        },
        teal: {
          100: { value: "#008081" },
          200: { value: "#1A8D8E" },
          300: { value: "#33999A" },
          400: { value: "#4DA6A7" },
          500: { value: "#66B3B4" },
          600: { value: "#80C0C1" },
          700: { value: "#99CCCC" },
          800: { value: "#B3D9D9" },
          900: { value: "#E7F2F2" },
        },
        red: {
          100: { value: "#FF4C4B" },
          200: { value: "#E64444" },
          300: { value: "#CC3C3C" },
          400: { value: "#FF5D5D" },
          500: { value: "#FF6F6F" },
          600: { value: "#FF8181" },
          700: { value: "#FF9393" },
          800: { value: "#FFB7B7" },
          900: { value: "#FFEDED" },
        },
        purple: {
          100: { value: "#574191" },
          200: { value: "#68549C" },
          300: { value: "#7967A7" },
          400: { value: "#9A8DBD" },
          500: { value: "#ABA0C8" },
          600: { value: "#BCB3D3" },
          700: { value: "#CDC7DE" },
          800: { value: "#DDDAEA" },
          900: { value: "#EEECF4" },
        },
        equity: {
          100: { value: "#ECEFF6" },
          200: { value: "#EEECF4" },
          300: { value: "#FFF0EB" },
          400: { value: "#ECF9F3" },
        }
      },
      fonts: {
        body: { value: "Nunito Sans" },
      },
    },
    
  },
})

const queryClient = new QueryClient()

function App() {
  return (
    <AuthProvider>
      <ViewerProvider>
        <ChakraProvider value={theme}>
          <QueryClientProvider client={queryClient}>
            <Router />
          </QueryClientProvider>
        </ChakraProvider>
      </ViewerProvider>
    </AuthProvider>
  )
}

export default App
